import React, {useState} from 'react';
import {TextField} from '@mui/material';
import {Editor} from 'react-draft-wysiwyg';
import {stateToHTML} from 'draft-js-export-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {EditorState, convertToRaw, convertFromRaw} from 'draft-js';
import PdfLoader from '../helper/PdfLoader';
import ImageLoader from '../helper/ImageLoader';

type Props = {
  item: any;
  index: number;
  setDisplayPocToolContent: Function;
  displayPocToolContent: any;
};

export default function ContentTypeSwitch(props: Props) {
  // This component places the necessary element based on the item type.
  const {item, index, setDisplayPocToolContent, displayPocToolContent} = props;

  let contentState;
  if (item.rawContentState) {
    contentState = convertFromRaw(item.rawContentState);
    contentState = EditorState.createWithContent(contentState);
  } else {
    contentState = EditorState.createEmpty();
  }

  const [editorState, setEditorState] = useState(contentState);

  const toolBarOptions = {
    options: ['inline', 'list', 'link'],
    inline: {
      options: ['bold', 'italic', 'superscript', 'subscript', 'underline'],
    },
    list: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ['unordered'],
    },
  };

  const handleOnEditorStateChange = result => {
    setEditorState(result);
    return setDisplayPocToolContent(
      displayPocToolContent.map((item, itemIndex) => {
        if (itemIndex === index)
          return {
            ...item,
            rawContentState: convertToRaw(result.getCurrentContent()),
            value: stateToHTML(result.getCurrentContent(), {
              inlineStyles: {
                SUPERSCRIPT: {element: 'sup'},
                SUBSCRIPT: {element: 'sub'},
              },
            }),
          };
        return item;
      }),
    );
  };
  const handleSetThumbnail = (result, fileName) => {
    setDisplayPocToolContent(
      displayPocToolContent.map((item, itemIndex) => {
        if (itemIndex === index)
          return {
            ...item,
            value: result,
            fileName: fileName,
          };
        return item;
      }),
    );
  };
  const handleTextFieldOnChange = event => {
    setDisplayPocToolContent(
      displayPocToolContent.map((item, itemIndex) => {
        if (itemIndex === index)
          return {
            ...item,
            value: event.target.value,
          };
        return item;
      }),
    );
  };

  switch (item.type) {
    case 'paragraph':
      return (
        <Editor
          handlePastedText={() => false}
          stripPastedStyles={true}
          editorStyle={styles.editorStyle}
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          contentStyle={styles.contentStyle}
          onEditorStateChange={handleOnEditorStateChange}
          toolbar={toolBarOptions}
        />
      );
    case 'img':
      return (
        <ImageLoader
          displayPocToolContent={displayPocToolContent}
          handleSetThumbnail={handleSetThumbnail}
          index={index}
          item={item}
          handleTextFieldOnChange={handleTextFieldOnChange}
          setDisplayPocToolContent={setDisplayPocToolContent}
        />
      );
    case 'pdf':
      return (
        <PdfLoader
          displayPocToolContent={displayPocToolContent}
          handleSetThumbnail={handleSetThumbnail}
          index={index}
          item={item}
          handleTextFieldOnChange={handleTextFieldOnChange}
          setDisplayPocToolContent={setDisplayPocToolContent}
        />
      );
    case 'video':
      return (
        <TextField
          id="outlined-basic"
          value={item.value}
          style={{color: '#FF5C00'}}
          variant="standard"
          placeholder={'Add Video URL'}
          onChange={handleTextFieldOnChange}
        />
      );
    default:
      return (
        <TextField
          id="outlined-basic"
          value={item.value}
          style={{color: '#FF5C00'}}
          variant="standard"
          onChange={handleTextFieldOnChange}
        />
      );
  }
}

const styles = {
  contentStyle: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '150%',
    display: 'flex',
    alignItems: 'center',
    color: '#000000',
  },
  editorStyle: {maxHeight: 300, height: '100%'},
  textFieldStyle: {
    color: '#FF5C00',
    width: '100%',
  },
};
